// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"9a3ffffe","247":"a1ad03f8","627":"240b33bc","653":"f77421d3","834":"8dbab304","867":"8c2c0b39","923":"79d9c2e3","938":"5043dba2"}[chunkId] + ".chunk.js";
};